//存疾病数据的全部数据列表
import { GET_DISEASES_HISTORY_DATA, SET_DISEASES_HISTORY_DATA, GET_DISEASE_DISEASES_LIST, } from "./actionType";

const defaultState = {
  diseaseList: [{ name: "无", id: 0 }],//男女疾病列表
  diseaseHistory: [],//用于编辑的数据
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_DISEASES_HISTORY_DATA://存
      const getState = handleDiseasesHistory (action.diseaseHistory, state);
      return { ...getState };
    case SET_DISEASES_HISTORY_DATA://设置
      return { ...state, ...action.params };
    case GET_DISEASE_DISEASES_LIST: //存病种
      return { ...state, ...action.params };
    default:
      return state;
  }
};

//获取接口数据
const handleDiseasesHistory = (action, state) => {
  const newAction = [...action.list].sort ((a, b) => a.id - b.id);
  const newState = { ...state };
  switch (action.is_operation) {
    case 0:
      newState.diseaseHistory = [];
      break;
    case 1:
      newState.diseaseHistory = [{ name: "无", id: 0, values: 0 }];
      break;
    case 2:
      newState.diseaseHistory = newAction.map ((item) => ({
        name: item.element_name, id: item.element_id, values: item.values
      }));
      break;
    default:
  }
  return newState;
};
export default Reducer;
